export const MODULE_LEVEL = 'levels';
export const MODULE_OTHER = 'other';
